import { render, staticRenderFns } from "./CustomerInProcessTab.vue?vue&type=template&id=f1beb56e&scoped=true"
import script from "./CustomerInProcessTab.vue?vue&type=script&lang=js"
export * from "./CustomerInProcessTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerInProcessTab.vue?vue&type=style&index=0&id=f1beb56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1beb56e",
  null
  
)

export default component.exports